import { AxiosInstance } from "axios";
import {
  GetEventsProps,
  RegisterEventProps,
} from "../../types/calendar/events";

export const getEvents = (
  getEventsData: GetEventsProps,
  instance: AxiosInstance,
) => {
  return instance.post("CalendareventSearch", getEventsData);
};

export const registerTrainingEvent = (
  registerEvent: RegisterEventProps,
  instance: AxiosInstance,
) => {
  return instance.post("Trainings/Register", registerEvent);
};

export const getMeetingRoomDetails = (
  meetingLink: any,
  eventDate: string,
  instance: AxiosInstance,
) => {
  return instance.get(
    `MeetingRoomDetails?meetingLink=${meetingLink}&eventDate=${eventDate}`,
  );
};
